import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faCheck,
  faXmark,
  faEnvelope,
  faCircleExclamation,
  faBan,
} from "@fortawesome/sharp-regular-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { getAppealCurrentStatusLabel } from "shared/src/constants/appealCurrentStatus";
import styles from "./status-indicator.module.scss";

interface StatusIndicatorProps {
  currentStatus: string;
}

interface StatusDisplay {
  icon: IconDefinition;
  className: string;
}

const STATUS_DISPLAY: Record<string, StatusDisplay> = {
  EXPIRED: { icon: faXmark, className: styles.statusExpired },
  REFERRAL_IN_PROGRESS: { icon: faClock, className: styles.statusMuted },
  OVERTURNED: { icon: faCheck, className: styles.statusSuccess },
  UPHELD: { icon: faXmark, className: styles.statusError },
  SUBMITTED: { icon: faCheck, className: styles.statusSubmitted },
  IN_SUPPORT: { icon: faCircleExclamation, className: styles.statusWarning },
  IN_PROGRESS: { icon: faClock, className: styles.statusInProgress },
  CLOSED: { icon: faBan, className: styles.statusClosed },
  REFERRED: { icon: faEnvelope, className: styles.statusReferred },
};

const DEFAULT_DISPLAY: StatusDisplay = {
  icon: faEnvelope,
  className: styles.statusReferred,
};

export function StatusIndicator({ currentStatus }: StatusIndicatorProps) {
  const statusDisplay = STATUS_DISPLAY[currentStatus] ?? DEFAULT_DISPLAY;
  const label = getAppealCurrentStatusLabel(currentStatus);

  return (
    <div className={`${styles.statusIndicator} ${statusDisplay.className}`}>
      <FontAwesomeIcon icon={statusDisplay.icon} className={styles.icon} />
      <span className={styles.statusText}>{label}</span>
    </div>
  );
}
